<template>
  <a
    v-if="isExternalLink"
    target="_blank"
    v-on="$listeners"
    v-bind="$attrs"
    :href="to"
  >
    <slot />
  </a>
  <router-link
    v-else-if="to"
    v-bind="$attrs"
    :to="to"
  >
    <slot />
  </router-link>
  <div v-else>
    <slot />
  </div>
</template>

<script>
const IS_EXTERNAL_LINK_REG_EXP = new RegExp('^(?:[a-z+]+:)?//', 'i');

export default {
  props: {
    to: {
      type: [String, Object, null],
      default: null,
    },
  },
  computed: {
    isExternalLink() {
      return typeof this.to === 'string' && IS_EXTERNAL_LINK_REG_EXP.test(this.to);
    },
  },
};
</script>
